/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import Header from "./Header";
import SideBar from "./SideBar";
import { serverUrl } from "../../serverUrl";
import { toast } from "react-toastify";

export default function UnpaidInvoice() {
    const navigate = useNavigate();
    const [showSidebar, setShowSidebar] = useState(true);
    const [unpaidInvoice, setUnpaidInvoice] = useState([]);
    const [statusFilter, setStatusFilter] = useState("all");
    const [apartmentFilter, setApartmentFilter] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [sortType, setSortType] = useState("invoice");
    const [sortOrder, setSortOrder] = useState("asc");
    const [isLoading, setIsLoading] = useState(true);

    const itemsPerPage = 10;

    // Get access token
    const accessToken = localStorage.getItem("authTokens");
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;
    const config = { headers: { Authorization: `Bearer ${access}` } };

    useEffect(() => {
        const token = localStorage.getItem("authTokens");
        if (!token) {
            navigate("/login");
            return;
        }

        setIsLoading(true);
        const parsedTokens = JSON.parse(token);
        const decodedToken = jwt_decode(token);
        const userId = decodedToken.user_id;

        serverUrl
            .get(`/landlord/landlord/?user_id=${userId}`, config)
            .then((res) => {
                const landlordId = res.data.results[0].id;
                serverUrl
                    .get(`/landlord/${landlordId}/unpaid-invoices`, config)
                    .then((res) => {
                        setUnpaidInvoice(res.data.unpaid_invoices);
                        setIsLoading(false);
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoading(false);
                    });
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
            });
    }, [navigate]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(0);
    };
    
    const handleSort = (sortField) => {
        if (sortType === sortField) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortType(sortField);
            setSortOrder("asc");
        }
    };
    
    const handleStatusFilterChange = (event) => {
        setStatusFilter(event.target.value);
        setCurrentPage(0);
    };
    
    const handleApartmentFilterChange = (event) => {
        setApartmentFilter(event.target.value);
        setCurrentPage(0);
    };

    const sortedData = [...unpaidInvoice].sort((a, b) => {
        const sortValueA = typeof a[sortType] === "string" ? a[sortType].toLowerCase() : a[sortType];
        const sortValueB = typeof b[sortType] === "string" ? b[sortType].toLowerCase() : b[sortType];
        
        if (sortValueA < sortValueB) return sortOrder === "asc" ? -1 : 1;
        if (sortValueA > sortValueB) return sortOrder === "asc" ? 1 : -1;
        return 0;
    });

    const filteredData = sortedData.filter((item) => {
        const searchableFields = Object.values(item).join(" ").toLowerCase();
        const matchesSearch = searchableFields.includes(searchQuery.toLowerCase());
        const matchesStatus = statusFilter === "all" || item.status === statusFilter;
        const matchesApartment = apartmentFilter === "all" || item.apartment === apartmentFilter;

        return matchesSearch && matchesStatus && matchesApartment;
    });

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const displayedItems = filteredData.slice(startIndex, endIndex);

    const handlePrevPage = () => setCurrentPage((prev) => prev - 1);
    const handleNextPage = () => setCurrentPage((prev) => prev + 1);
    const handlePageClick = (page) => setCurrentPage(page);

    const handleDownloadInvoice = (invoiceId) => {
        serverUrl
            .get(`/tenant/generate_pdf_invoice/?invoice_id=${invoiceId}&download=true`, config)
            .then((res) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", "invoice_report.pdf");
                document.body.appendChild(link);
                link.click();
                toast.success("Successfully Downloaded Your Invoice Report");
            })
            .catch((error) => console.log(error));
    };

    // CSV Export Functionality
    const handleDownloadCSV = () => {
        const headers = [
            "Invoice ID",
            "Unit Number",
            "Apartment",
            "Amount",
            "Balance",
            "Status",
            "Reference",
            "Utility",
            "Tenant",
            "Tenant Phone",
            "Month",
            "Year"
        ];
        const rows = filteredData.map(invoice => [
            `INV${invoice.invoice_id}`,
            invoice.house_name,
            invoice.apartment,
            `KSH. ${parseInt(invoice.amount)?.toLocaleString('en-us')}`,
            `KSH. ${parseInt(invoice.balance_amount)?.toLocaleString('en-us')}`,
            invoice.status,
            invoice.reference === "expense" ? "Utility" : invoice.reference,
            invoice.utility,
            invoice.tenant_name,
            invoice.tenant_phone,
            invoice.month,
            invoice.year
        ]);
        const csvContent = [
            headers.join(","),
            ...rows.map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
        ].join("\r\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "unpaid_invoices.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const uniqueApartments = [...new Set(unpaidInvoice.map((item) => item.apartment))];

    const getSortIcon = (field) => {
        if (sortType === field) {
            return sortOrder === "asc" ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
            ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            );
        }
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 opacity-30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
            </svg>
        );
    };

    const getStatusBadgeClass = (status) => {
        switch(status) {
            case 'partial':
                return 'bg-yellow-100 text-yellow-800';
            case 'unpaid':
                return 'bg-red-100 text-red-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    // Generate page numbers for pagination
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            for (let i = 0; i < totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always include first page
            pages.push(0);
            
            let startPage = Math.max(1, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            
            if (currentPage <= 2) {
                endPage = 3;
            } else if (currentPage >= totalPages - 3) {
                startPage = totalPages - 4;
            }
            
            // Add ellipsis after first page if needed
            if (startPage > 1) {
                pages.push('ellipsis-left');
            }
            
            // Add middle pages
            for (let i = startPage; i <= endPage; i++) {
                if (i > 0 && i < totalPages - 1) {
                    pages.push(i);
                }
            }
            
            // Add ellipsis before last page if needed
            if (endPage < totalPages - 2) {
                pages.push('ellipsis-right');
            }
            
            // Always include last page
            pages.push(totalPages - 1);
        }
        
        return pages;
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Unpaid Invoices</h2>
                <p className="text-gray-600">Manage and track all unpaid invoices</p>
            </div>
            
            {/* Filters and Search */}
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
                <div className="relative w-full md:w-64">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                        </svg>
                    </div>
                    <input
                        type="text"
                        placeholder="Search invoices..."
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3">
                    <select 
                        value={statusFilter} 
                        onChange={handleStatusFilterChange}
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="all">All Payments</option>
                        <option value="unpaid">Unpaid</option>
                        <option value="partial">Partially Paid</option>
                    </select>
                    
                    <select 
                        value={apartmentFilter} 
                        onChange={handleApartmentFilterChange}
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="all">All Properties</option>
                        {uniqueApartments.map((apartment, index) => (
                            <option key={index} value={apartment}>{apartment}</option>
                        ))}
                    </select>
                    
                    <button 
                        onClick={handleDownloadCSV}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        Export CSV
                    </button>
                </div>
            </div>
            
            {/* Table */}
            <div className="overflow-x-auto rounded-lg">
                <table className="min-w-full divide-y divide-gray-200 bg-white">
                    <thead className="bg-gray-50">
                        <tr>
                            {[
                                { id: "invoice_id", label: "Invoice ID" },
                                { id: "house_name", label: "Unit Number" },
                                { id: "apartment", label: "Apartment" },
                                { id: "amount", label: "Amount" },
                                { id: "balance_amount", label: "Balance" },
                                { id: "status", label: "Status" },
                                { id: "reference", label: "Reference" },
                                { id: "utility", label: "Utility" },
                                { id: "tenant_name", label: "Tenant" },
                                { id: "tenant_phone", label: "Tenant Phone" },
                                { id: "month", label: "Month" },
                                { id: "year", label: "Year" }
                            ].map((column) => (
                                <th 
                                    key={column.id}
                                    onClick={() => handleSort(column.id)}
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors"
                                >
                                    <div className="flex items-center">
                                        {column.label}
                                        {getSortIcon(column.id)}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {isLoading ? (
                            <tr>
                                <td colSpan="12" className="px-6 py-8 text-center">
                                    <div className="flex justify-center items-center">
                                        <svg className="animate-spin h-8 w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    </div>
                                </td>
                            </tr>
                        ) : displayedItems.length === 0 ? (
                            <tr>
                                <td colSpan="12" className="px-6 py-8 text-center">
                                    <div className="flex flex-col items-center justify-center text-gray-500">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <p className="text-lg font-medium">No invoices found</p>
                                        <p className="text-sm">Try adjusting your search or filter criteria</p>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            displayedItems.map((invoice) => (
                                <tr key={invoice.id} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                        INV{invoice.invoice_id}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <Link 
                                            to={`/selected-house/${invoice.house_id}`}
                                            className="text-blue-600 hover:text-blue-800 hover:underline"
                                        >
                                            {invoice.house_name}
                                        </Link>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {invoice.apartment}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                        KSH. {parseInt(invoice.amount)?.toLocaleString('en-us')}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-red-600">
                                        KSH. {parseInt(invoice.balance_amount)?.toLocaleString('en-us')}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className={`px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadgeClass(invoice.status)}`}>
                                            {invoice.status}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">
                                        {invoice.reference === "expense" ? "Utility" : invoice.reference}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">
                                        {invoice.utility}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">
                                        {invoice.tenant_name}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {invoice.tenant_phone}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 capitalize">
                                        {invoice.month}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {invoice.year}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            
            {/* Pagination */}
            {!isLoading && filteredData.length > 0 && (
                <div className="flex items-center justify-between mt-6 px-2">
                    <div className="text-sm text-gray-700">
                        Showing <span className="font-medium">{startIndex + 1}</span> to <span className="font-medium">{Math.min(endIndex, filteredData.length)}</span> of <span className="font-medium">{filteredData.length}</span> results
                    </div>
                    
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={handlePrevPage}
                            disabled={currentPage === 0}
                            className={`px-3 py-1.5 rounded-md border ${currentPage === 0 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                        >
                            Previous
                        </button>
                        
                        <div className="hidden sm:flex items-center space-x-1">
                            {getPageNumbers().map((page, index) => (
                                page === 'ellipsis-left' || page === 'ellipsis-right' ? (
                                    <span key={index} className="px-3 py-1.5 text-gray-500">...</span>
                                ) : (
                                    <button
                                        key={index}
                                        onClick={() => handlePageClick(page)}
                                        className={`px-3 py-1.5 rounded-md ${currentPage === page ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'}`}
                                    >
                                        {page + 1}
                                    </button>
                                )
                            ))}
                        </div>
                        
                        <button
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages - 1 || totalPages === 0}
                            className={`px-3 py-1.5 rounded-md border ${currentPage === totalPages - 1 || totalPages === 0 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}